import { default as videojs } from 'video.js';
import { TitleBarOptions } from '../models';
import { ComponentBase } from './component-base';
import { VideoDescription } from './video-description';
import { VideoTitle } from './video-title';
import Component = videojs.Component;

export class TitleBar extends ComponentBase {

    static readonly ComponentName: string = 'TitleBar';

    constructor(player: videojs.Player, options?: TitleBarOptions, readyCallback?: Component.ReadyCallback) {
        super(player, {...options, name: 'TitleBar'}, readyCallback);
        this.addChild(VideoTitle.ComponentName, {});
        this.addChild(VideoDescription.ComponentName, {});
    }

    name(): string {
        return TitleBar.ComponentName;
    }

    updateTextContent(textContent?: { title?: string, description?: string }): void {
        if (textContent.title) {
            (<VideoTitle>this.getChild(VideoTitle.ComponentName)).updateTextContent(textContent?.title);
            this.getChild(VideoTitle.ComponentName).removeClass('vjs-planet-hide');
        }
        if (textContent.description) {
            (<VideoDescription>this.getChild(VideoDescription.ComponentName)).updateTextContent(textContent?.description);
            this.getChild(VideoDescription.ComponentName).removeClass('vjs-planet-hide');
        }
    }

    createEl(): Element {
        return super.createEl('div', {
            className: 'vjs-title-bar',
        });
    };
}

videojs.registerComponent(TitleBar.ComponentName, TitleBar);
